export default function (data, props) {
    if(data.success && data.result) {
        props.title = data.result.title;
        props.content = data.result.description;
        props.imageUrl = data.result.image;
    }
}